export default {"src":"/_next/static/media/youtube.a1db5322.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};